import React, { useEffect, useState } from "react";
import styles from "./Setting.module.css";
import { FiSearch } from "react-icons/fi";
import BlockUserList from "./BlockUsersList.js";
import axios from "axios";
import { GET_HCP_LIST } from "../utils/constants";

const Setting = () => {
  const [showData, setShowData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(GET_HCP_LIST);
      setShowData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(showData);
  return (
    <div>
      <div className={styles.setting_parent}>
        <div className={styles.search_section}>
          <FiSearch color="white" size="1.7rem" />
          <input
            className={styles.search_input}
            type="text"
            placeholder="Search User by name"
          />
        </div>
        <BlockUserList showData={showData} />
        <BlockUserList />
        <BlockUserList />
      </div>
    </div>
  );
};

export default Setting;
